import { ActionTree } from 'vuex';
import { RootState } from '@/store';

import api from './api';
import { Mutations } from './mutations';
import { ErrorApi } from '@/core/api/ErrorApi';
import Notify from '@/shared/services/Notify/Notify';
import { ScheduleState, MatchDay, Match } from './models';

export enum Actions {
  FETCH_MATCH_DAYS = 'FETCH_MATCH_DAYS',
  FETCH_MATCH_DAY_MATCHES = 'FETCH_MATCH_DAY_MATCHES',
  FETCH_AND_UPDATE_MATCH_DAY_MATCHES = 'FETCH_AND_UPDATE_MATCH_DAY_MATCHES',
  FETCH_DATA_FROM_LACZYNASPILKA = 'FETCH_DATA_FROM_LACZYNASPILKAPL',
  DELETE_MATCH = 'DELETE_MATCH',
}

export const actions: ActionTree<ScheduleState, RootState> = {

  async [Actions.FETCH_MATCH_DAYS]({ commit }) {
    await api.fetchMatchDays().then(
      (payload: MatchDay[]) => {
          commit(Mutations.SET_ALL_MATCH_DAYS, payload);
      },
      (error: ErrorApi) => {
        Notify.errorApi(error);
      },
    );
  },

  async [Actions.FETCH_MATCH_DAY_MATCHES]({ commit }, matchDayId: number) {
    await api.fetchMatchDayMatches(matchDayId).then(
      (payload: Match[]) => {
        if(payload.length > 0){
          commit(Mutations.SET_MATCHES_FOR_MATCH_DAY, payload);
        }
      },
      (error: ErrorApi) => {
        Notify.errorApi(error);
      },
    );
  },

  async [Actions.FETCH_DATA_FROM_LACZYNASPILKA]({ dispatch }, matchDayId: number) {
    await api.fetchDataFromLaczyNasPilka(matchDayId).then(
      () => {
        Notify.success(`Dane z laczynaspilka.pl zostały pomyślnie pobrane.`);
        dispatch(Actions.FETCH_MATCH_DAY_MATCHES, matchDayId);
      },
      (error: ErrorApi) => {
        Notify.errorApi(error);
      },
    );
  },

  async [Actions.DELETE_MATCH]({ dispatch },  match: Match) {
    await api.deleteMatch(match.id as number).then(
      () => {
        Notify.success(`Spotkanie meczowe zostało usunięte.`);
        dispatch(Actions.FETCH_MATCH_DAY_MATCHES, match.matchDayId as number);
      },
      (error: ErrorApi) => {
        Notify.errorApi(error);
      },
    );
  },

};
